export function truncateText(text: string, maxWidth: number,small=false) {
  const charWidth = 10; // Average width of a character (adjust if necessary)
  let  maxChars = Math.floor(maxWidth / charWidth);
  if (small) {
    maxChars = 1;
  }
  return text.length > maxChars ? text.slice(0, maxChars > 2 ? maxChars - 3: maxChars) + "..." : text;
}
